// Third party
import {
  SearchRegionForListingsByPlaceNameWithSingleAssetDocument,
  SearchRegionForListingsByPlaceNameWithSingleAssetQuery,
  SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables,
} from '@gql';
import { ErrorPolicy } from '@apollo/client';

// Utils
import { createApolloClient } from '../apollo-node-client';

type Options = {
  variables: SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables;
  errorPolicy?: ErrorPolicy;
};

export const imperativeNodeListingsByPlaceNameQuery = async (
  options: Options
) => {
  const apolloClient = createApolloClient();

  return await apolloClient.query<SearchRegionForListingsByPlaceNameWithSingleAssetQuery>(
    {
      ...{ query: SearchRegionForListingsByPlaceNameWithSingleAssetDocument },
      ...options,
    }
  );
};
